export default __webpack_public_path__ + "static/media/258735fccf26eeb6.6a2be15bf90221dbeddc01495609f507.svg";